import { ENV_DEVELOPMENT } from '@vfde-sails/constants';

/**
 * renderMockCMSContent
 */
export const renderMockCMSContent = (htmlMarkup, targetId = 'app') => {
    if (process.env.NODE_ENV === ENV_DEVELOPMENT) {
        document.getElementById(targetId).innerHTML = htmlMarkup;
    }
};
